import { IBoundedByCornerSchema } from '../repositories/geo-temp-layer/entities/catalog_item/BoundedByCornerSchema';
import { IBoundedByCorner } from '../types/location';

export const prepareBoundedByCorner = ({ lat, lng }: IBoundedByCornerSchema): IBoundedByCorner => {
  return {
    lat,
    lng,
  };
};
